import React, { useEffect } from "react";
import { useRechargeModel } from "./rechargeModel";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { YhBox } from "@/components/YhBox";
import { RechargeDataTable } from "./DataTable";

export const RechargeDataBox = () => {
    const {
        // dataSource,
        rechargeAmount,
        loadData,
        // selectedRowKeys,
        // setSelectedData,
    } = useRechargeModel();

    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [])

    // useEffect(() => {
    //     let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
    //     const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
    //     setSelectedData(selectedData)
    // }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "充值总额",
            value: rechargeAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
    ]


    return (
        <>
            <YhBox title={"充值记录"} descriptions={desc}>
                <RechargeDataTable />
            </YhBox>
        </>
    )
}